<div class="flex items-center space-x-2">
	@if( { canUpdate:(workspace$canUpdate | async)} ; as canUpdate ) {
	<div
		(click)=" canUpdate.canUpdate ? updateWorkinghourDay() : null "
		[ngClass]="{ 'mat-bdw-10 dark:mat-bd-20 pl-4 pr-1': (isActive$ | async) , 'cursor-pointer' : canUpdate.canUpdate }"
		class="flex h-12 items-center space-x-3 rounded-lg wflex-[1_0_auto] "
	>
		<ng-container *ngIf="{ stats: activeTime$stats | async, visit: lastVisit$ | async } as time">
			<ng-container
				*ngTemplateOutlet="
          time.stats ? statView : time.visit ? null : null;
          context: { $implicit: time.stats, visit: time.visit }
        "
			></ng-container>
		</ng-container>
		<div
			(click)="$event.preventDefault(); $event.stopPropagation()"
			class="flex items-center justify-end space-x-1 wflex-[1_0_auto]"
		>
			<ng-container *ngTemplateOutlet="(isActive$ | async) ? activeActions : defaultActions"></ng-container>
		</div>
	</div>
	}
	<ng-container> <ng-container *ngTemplateOutlet="manualAdd"></ng-container> </ng-container>
</div>
<ng-template
	#statViewInitial
	let-visit="visit"
>
	<div class="mat-typography flex flex-col pt-0.5 leading-none">
		<div class="mb-0.5 flex items-end space-x-1">
			<span class="self-start">{{ visit.visit | formatDate: 'time' }}</span>
		</div>
		<span class="mat-hint text-sm leading-none">{{ 'comego.first_app_visit' | translate }}</span>
	</div>
</ng-template>
<ng-template
	#statView
	let-stats
>
	<div class="mat-typography flex flex-col pt-0.5 leading-none">
		<div class="mb-0.5 flex items-end space-x-1">
			<span class="leading-none">{{ stats.duration | parseMsAsDuration }}</span>
			<span class="mat-hint text-sm leading-none">{{ stats.start | formatDate: 'time' }}</span>
		</div>
		<span
			[ngClass]="{ 'mat-hint': !stats.paused, 'mat-text-accent': stats.paused }"
			class="text-sm leading-none"
			>{{
				(stats.paused ? 'comego.paused_since' : 'comego.tracking_since') | translate
			}}</span
		>
	</div>
</ng-template>
<ng-template #pauseAction>
	<button
		(click)="$event.preventDefault(); $event.stopPropagation(); handle('update', 'pause')"
		[disabled]="(loading$.value$ | async) || (actionCooldown$ | async) || (isSameMinute$ | async)"
		[matTooltip]="'comego.state.pause' | translate"
		class="mat-button-square wflex-[0_0_auto]"
		mat-button
	>
		<mat-icon>pause_circle</mat-icon>
	</button>
</ng-template>
<ng-template #resumeAction>
	<button
		(click)="$event.preventDefault(); $event.stopPropagation(); handle('update', 'play')"
		[disabled]="(loading$.value$ | async) || (actionCooldown$ | async) || (isSameMinute$ | async)"
		[matTooltip]="'comego.state.resume' | translate"
		class="mat-button-square wflex-[0_0_auto]"
		mat-button
	>
		<mat-icon>not_started</mat-icon>
	</button>
</ng-template>
<ng-template #activeActions>
	<ng-container *ngTemplateOutlet="!(paused$ | async) ? pauseAction : resumeAction"></ng-container>
	<button
		(click)="handle('stop')"
		[disabled]="(loading$.value$ | async) || (actionCooldown$ | async) || (isSameMinute$ | async)"
		class="mat-comego-stop h-10 !rounded-r-lg wflex-[0_0_auto]"
		mat-raised-button
	>
		<div class="flex items-center space-x-2">
			<div class="flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
				<div class="mat-size-4"><mat-icon inline>logout</mat-icon></div>
			</div>
			<span>{{ 'comego.check_out' | translate }}</span>
		</div>
	</button>
</ng-template>
<ng-template #defaultActions>
	<ng-container *ngIf="{ ho: hasOverlappingEntry$ | async, dr: disableRecording | async } as ci">
		<span
			[matTooltip]="
				ci.ho ? ('comego.checkInBlockedByExistingEntry' | translate) : ci.dr ? ('comego.recordingEnabledIn' | translate: { date: disabledUntil.value }) : ''
			"
		>
			<button
				(click)="handle('start')"
				[disabled]="(loading$.value$ | async) || (actionCooldown$ | async) || (disableRecording | async) || (hasOverlappingEntry$ | async)"
				class="mat-comego-start h-10 !rounded-lg wflex-[0_0_auto]"
				mat-raised-button
			>
				<div class="flex items-center space-x-2">
					<div class="flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
						<div class="mat-size-4"><mat-icon inline>login</mat-icon></div>
					</div>
					<span>{{ 'comego.check_in' | translate }}</span>
				</div>
			</button>
		</span>
	</ng-container>
</ng-template>
<ng-template #manualAdd>
	@if( { comego: workspace$canCreate | async, absence: workspace$canCreateAbsences | async}; as permission) {
	@if(permission.comego || permission.absence) {
	<div class="flex items-center rounded-lg border border-muted px-1 h-10 gap-1">
		<button
			(click)="handle('manual', permission.comego ? 'default' : 'absence')"
			[disabled]="(loading$.value$ | async) || (actionCooldown$ | async)"
			[ngClass]="{
        '!rounded-r-none !rounded-l': permission.comego && permission.absence,
        '!rounded': !(permission.comego && permission.absence),
      }"
			class="h-8 !leading-8 !px-2 flex-auto flex-shrink-0"
			mat-button
		>
			<div class="flex items-center gap-2">
				<mat-icon>add</mat-icon>
				<span>{{ (permission.comego ? 'comego.workingtime' : 'comego.createAbsence') | translate }}</span>
			</div>
		</button>
		@if(permission.comego && permission.absence) {
		<button
			[disabled]="(loading$.value$ | async) || (actionCooldown$ | async)"
			[matMenuTriggerFor]="manualAddMenu"
			class="mat-icon-button mat-icon-button-flex !size-8 !rounded-l-none !rounded-r flex-shrink-0"
			mat-button
		>
			<div class="flex items-center"><mat-icon>arrow_drop_down</mat-icon></div>
		</button>
		}
	</div>
	}
	<mat-menu #manualAddMenu="matMenu">
		<button
			(click)="handle('manual', 'absence')"
			[disabled]="(loading$.value$ | async) || (actionCooldown$ | async)"
			mat-menu-item
		>
			{{ 'comego.createAbsence' | translate }}
		</button>
	</mat-menu>
	}
</ng-template>
<ng-template #btnLoading></ng-template>
